<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<!-- Linha 1 - Filtros: painel flutuante (padrão FireAlertsFilter) com os
			     multi-selects de fazenda/talhão/estrato e a importação de CSV em
			     RASCUNHO (aplica só no "filtrar" do painel), + busca livre;
			     colunas/exportar à direita. -->
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<VincularPrognoseFilter
						:fazendas="fazendasFiltro"
						:talhoes="talhoesFiltro"
						:estratos="estratosFiltro"
						:combinacoes="combinacoesFiltro"
						@filtrar="onFiltrar"
						@limpar="onLimparFiltros"
					/>
					<InputSearch
						v-model="textFilter"
						class="busca-filtro"
						:placeholder="$t('search')"
					/>
				</div>
				<div class="container__crudactions__filtercollums__collumns">
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						class="vincular-acoes__botao-exportar"
						:loading="exportando"
						@click="downloadCSVVincularPrognose()"
					/>
				</div>
			</div>

			<!-- Resumo do CSV importado: quantos itens viraram filtro e o que não bateu
			     com o acervo (código/nome não encontrado nos dropdowns). -->
			<div
				v-if="csvResumo"
				class="csv-resumo"
			>
				<span class="csv-resumo__ok">
					<i class="fas fa-file-csv" />
					{{ $t('csvFilterApplied') }}: {{ csvResumo.fazendas }} {{ $t('farm').toLowerCase() }}(s),
					{{ csvResumo.talhoes }} {{ $t('talhao').toLowerCase() }}(s)
				</span>
				<span
					v-if="csvResumo.naoEncontrados.length > 0"
					class="csv-resumo__erro"
					:title="csvResumo.naoEncontrados.join(', ')"
				>
					<i class="fas fa-exclamation-triangle" />
					{{ $t('csvItemsNotFound') }}: {{ csvResumo.naoEncontrados.length }}
					<button
						type="button"
						class="csv-resumo__copiar"
						:title="$t('copiar')"
						@click="copiarNaoEncontrados"
					>
						{{ naoEncontradosCopiados ? $t('copiado') : $t('copiar') }}
					</button>
				</span>
			</div>

			<!-- Linha 2 - Ações em lote: barra destacada com botões de comando à esquerda
			     e status de seleção à direita, separada visualmente dos filtros acima -->
			<div class="vincular-acoes">
				<div class="vincular-acoes__botoes">
					<Button
						:label="$t('applyPrognosis')"
						color="trv-default"
						semantic-class="mini"
						width-auto
						:disabled="isApplyProgButtonDisabled"
						@click="prognoseAplica"
					/>
					<Button
						:label="$t('processing')"
						color="trv-primary"
						outlined
						semantic-class="mini"
						width-auto
						@click="$router.push('/prognose/processamentos?tipo=Vinculo')"
					/>
					<span
						v-if="selectedCount > 0"
						class="vincular-acoes__separador"
					/>
					<!-- "Selecionar todos (carregados)" foi removido: o checkbox do
					     CABEÇALHO da grade já seleciona o resultado filtrado INTEIRO
					     (inclusive o que ainda não foi carregado do servidor). -->
					<Button
						v-if="selectedCount > 0"
						:label="$t('clearSelected')"
						color="trv-primary"
						semantic-class="mini"
						width-auto
						outlined
						@click="limparSelecao"
					/>
				</div>
				<span
					v-if="selectedCount > 0"
					class="vincular-acoes__contador vincular-acoes__contador--ativo"
				>
					<i class="fas fa-check-circle" />
					{{ textoSelecao }}
				</span>
			</div>
		</div>
		<CrudTable
			:key="tableKey"
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotalPagination.items"
			:table-configuration="tableConfiguration"
			:mostrar-btn-editar="false"
			:show-sort-options="true"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
			@selectAllChanged="onSelecionarTudo"
		/>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				:reset-index-on-batch-change="false"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<DropdownFk
					v-model="model.prognoseEscolhida"
					:label="$t('prognosis')"
					:dropdown-options="formatedPrognose"
				/>
				<InputText
					v-model="model.horizonteDeProjecao"
					:label="`${$t('projectionHorizon')} (${$t('months')})`"
				/>
				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="!camposObrigatorios"
						:loading="aplicandoPrognose"
						@click="saveClick"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import CrudForm from '../../../components/CrudForm/CrudForm'
import CrudTable from '../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../components/InputSearch/InputSearch'
import InputText from '../../../components/InputText/InputText'
import GridPagination from '../../../components/GridPagination/GridPagination'
import VincularPrognoseFilter from '../../../components/Prognose/Vincular/VincularPrognoseFilter'

import ControllingPaginationMixins from '../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../mixins/RegistersMixins'

import {
	getAllAplicaPrognose,
	getAllPrognose,
	filtrosVincularDropdown,
} from '../../../services/requests/PrognoseRequests'
import { vinculaPrognoseAsync } from '../../../services/requests/VinculaPrognoseRequests'

import download from 'downloadjs'

export default {
	components: {
		Button,
		CrudTable,
		CrudForm,
		InputText,
		DropdownCheckbox,
		InputSearch,
		GridPagination,
		DropdownFk,
		VincularPrognoseFilter,
	},
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			aplicandoPrognose: false,
			exportando: false,
			isApplyProgButtonDisabled: false,
			totalRecords: 0,
			// Filtros estruturados: listas brutas dos dropdowns do Registry (props do
			// painel VincularPrognoseFilter) e os IDs APLICADOS pelo "filtrar" do
			// painel — o rascunho vive dentro do componente.
			fazendasFiltro: [],
			talhoesFiltro: [],
			estratosFiltro: [],
			// Triplas (fazendaId/estratoId/talhaoId) existentes no acervo — base da
			// CASCATA dos dropdowns do painel.
			combinacoesFiltro: [],
			filtrosAplicados: {
				FazendasIds: [],
				TalhoesIds: [],
				EstratosIds: [],
			},
			// Resumo do CSV importado: { fazendas, talhoes, naoEncontrados: [] }
			csvResumo: null,
			naoEncontradosCopiados: false,
			batchSize: 100,
			actualBatchSize: null, // Tamanho real retornado pelo backend
			// Próxima página a pedir ao servidor (contador EXPLÍCITO): derivar a
			// página por divisão do total carregado quebra quando um lote vem com
			// mais que batchSize (tradicional + single-trees somam as duas fontes)
			// — o skip do servidor é por página, e a derivação duplicava/pulava.
			proximaPaginaServidor: 1,
			allLoadedData: [],
			isLoadingMore: false,
			currentStartIndex: 0,
			currentEndIndex: 10,
			headersSelecionados: [
				'prognoseDescricao',
				'inventarioFlorestalDescricao',
				'idade',
				'dataDoPlantio',
				'plantioCodigo',
				'talhaoCodigo',
				'estratoDescricao',
				'fazendaDescricao',
			],
			teste: false,
			prognose: [],
			model: {
				prognoseEscolhida: null,
				horizonteDeProjecao: 0,
			},
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'descricao',
				titleCardPropertie: 'codigo',
			},

			tableHeaders: [
				{ key: 'fazendaDescricao', value: this.$t('farm'), isActive: true },
				{ key: 'talhaoCodigo', value: this.$t('talhao'), isActive: true },
				{
					key: 'estratoDescricao',
					value: this.$t('forestStratification'),
					isActive: true,
				},
				{
					key: 'plantioCodigo',
					value: this.$t('plantation'),
					isActive: true,
				},
				{
					key: 'dataDoPlantio',
					value: this.$t('plantationDate'),
					isActive: true,
				},
				{
					key: 'idade',
					value: `${this.$t('plantationAge')} (${this.$t('months')})`,
					isActive: true,
				},
				{
					key: 'inventarioFlorestalDescricao',
					value: this.$t('forestInventory'),
					isActive: true,
				},
				{
					key: 'isSingleTrees',
					value: `${this.$t('singleTrees')}?`,
					isActive: false,
				},
				{ key: 'sitio', value: this.$t('site'), isActive: false },
				{
					key: 'prognoseDescricao',
					value: this.$t('prognosis'),
					isActive: true,
				},
			],
		}
	},
	computed: {
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},

		camposObrigatorios() {
			return this.model.prognoseEscolhida && this.model.horizonteDeProjecao
		},

		/**
		 * Quantidade de plantios selecionados (checkbox) em toda a lista carregada,
		 * nao apenas na pagina visivel.
		 */
		selectedCount() {
			return this.modelList.filter((f) => f.isCheckedToDelete).length
		},

		/**
		 * Texto informativo da selecao. Deixa claro que a selecao cobre os plantios
		 * ja carregados quando ainda ha registros nao carregados do back.
		 */
		textoSelecao() {
			const selecionados = this.$t('selectedPlantings', { count: this.selectedCount })
			if (this.totalRecords > this.modelList.length) {
				const carregados = this.$t('loadedOfTotal', {
					loaded: this.modelList.length,
					total: this.totalRecords,
				})
				return `${selecionados} — ${carregados}`
			}
			return selecionados
		},

		formatedPrognose() {
			return this.prognose.map((m) => {
				return {
					id: m.id,
					[this.$t('code')]: m.codigo,
					[this.$t('description')]: m.descricao,
					[this.$t('date')]: new Date(m.dataDaPrognose).toLocaleString(),
					[this.$t('siteClassification')]: m.classificacaoDeSitioCodigo,
				}
			})
		},
		paginatedData() {
			return this.allLoadedData.slice(this.currentStartIndex, this.currentEndIndex)
		},
		tableKey() {
			// Chave única que força re-renderização quando dados ou índices mudam
			return `${this.modelList.length}-${this.atualStartIndex}-${this.atualEndIndex}`
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		modelList: {
			handler() {
				//  this.handleSelectionChanges();
				//const checadas = this.modelList.filter((f) => f.isCheckedToDelete);
				// var idades = checadas.map((m) => m.idade);
				// this.model.horizonteDeProjecao = Math.max.apply(null, idades);
				this.isApplyProgButtonDisabled =
					this.modelList.filter((f) => f.isCheckedToDelete).length === 0
			},
			deep: true,
		},
		textFilter(value) {
			// Remove espaços no início e no final
			const trimmedValue = value ? value.trim() : ''
			if (trimmedValue !== value) {
				this.textFilter = trimmedValue
				return
			}

			this.$refs.ref__pagination.resetToFirstPageInputHandle()
			if (trimmedValue) {
				// Com filtro, busca no servidor (mantendo os multi-selects aplicados)
				this.refreshTabela(0, this.quantityPerPage, trimmedValue)
			} else {
				// Sem texto, recarrega respeitando os filtros estruturados atuais
				this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
				this.modelList = []
				this.currentStartIndex = 0
				this.currentEndIndex = this.quantityPerPage
				this.atualStartIndex = 0
				this.atualEndIndex = this.quantityPerPage
				this.proximaPaginaServidor = 1
				getAllAplicaPrognose(0, this.batchSize, '', this.filtrosAtuais()).then((response) => {
					this.totalRecords = response.data.totalRegistros || 0
					const plantios = response.data.result
					if (plantios && plantios.length > 0) {
						// Guarda o tamanho real retornado pelo backend
						this.actualBatchSize = plantios.length
						plantios.forEach((plantio) => this.formatarDados(plantio))
						this.allLoadedData = plantios
						this.modelList = plantios
					}
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
				})
			}
		},
	},
	created() {
		this.quantityPerPage = 10
		getAllPrognose().then((response) => {
			const result = response.data
			this.prognose = result
		})

		// Opções dos filtros (não bloqueia a grid): SÓ fazendas/estratos/talhões que
		// existem no acervo processado — não o cadastro inteiro. Também é a base do
		// matching do CSV (código/nome -> id).
		filtrosVincularDropdown()
			.then((response) => {
				const opcoes = response.data?.result || {}
				this.fazendasFiltro = opcoes.fazendas || []
				this.estratosFiltro = opcoes.estratos || []
				this.talhoesFiltro = opcoes.talhoes || []
				this.combinacoesFiltro = opcoes.combinacoes || []
			})
			.catch(() => {
				this.fazendasFiltro = []
				this.estratosFiltro = []
				this.talhoesFiltro = []
				this.combinacoesFiltro = []
			})

		getAllAplicaPrognose(0, this.batchSize, '').then((response) => {
			this.totalRecords = response.data.totalRegistros || 0
			const plantios = response.data.result
			if (plantios && plantios.length > 0) {
				// Guarda o tamanho real retornado pelo backend
				this.actualBatchSize = plantios.length
				plantios.forEach((plantio) => this.formatarDados(plantio))
				this.allLoadedData = plantios
				this.modelList = plantios
			}
			this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
		})
	},
	methods: {
		// Sobrescreve o método do mixin para sincronizar os índices locais
		setStartEnd(startIndex) {
			this.atualStartIndex = startIndex
			this.atualEndIndex = startIndex + this.quantityPerPage
			this.currentStartIndex = startIndex
			this.currentEndIndex = startIndex + this.quantityPerPage
		},
		// Sobrescreve o método do mixin para atualizar a quantidade por página
		setQuantityPerPage(quantityPerPage) {
			this.quantityPerPage = quantityPerPage
			// Recalcula o endIndex com a nova quantidade
			this.atualEndIndex = this.atualStartIndex + quantityPerPage
			this.currentEndIndex = this.currentStartIndex + quantityPerPage
		},
		formatarDados(vinculaDados) {
			vinculaDados.idade = Number(vinculaDados.idade?.toFixed(0))
			vinculaDados.dataDoPlantio = new Date(vinculaDados.dataDoPlantio).toLocaleDateString()
			vinculaDados.isCheckedToDelete = false
		},
		refreshTabela(pageNumber, pageSize, filteringWord) {
			// Se tem filtro, faz busca nova no servidor
			if (filteringWord) {
				this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
				this.modelList = []
				this.currentStartIndex = 0
				this.currentEndIndex = this.quantityPerPage
				this.atualStartIndex = 0
				this.atualEndIndex = this.quantityPerPage
				this.proximaPaginaServidor = 1
				getAllAplicaPrognose(0, this.batchSize, filteringWord, this.filtrosAtuais()).then(
					(response) => {
						this.totalRecords = response.data.totalRegistros || 0
						const plantios = response.data.result
						if (!plantios || plantios.length === 0) {
							this.modelList = []
							this.allLoadedData = []
							this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
							return
						}
						// Guarda o tamanho real retornado pelo backend
						this.actualBatchSize = plantios.length
						plantios.forEach((plantio) => this.formatarDados(plantio))
						this.allLoadedData = plantios
						// modelList contém todos os dados carregados, o computed faz o slice para exibição
						this.modelList = plantios
						this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					},
				)
				return
			}

			this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
			this.modelList = []

			// Calcula quantos dados já foram carregados do backend
			const dadosCarregados = this.allLoadedData.length
			// Calcula quanto dado do backend precisamos ter carregado para exibir a página atual
			// Usa os índices de exibição que já foram setados pelo setStartEnd
			const endIndexNecessario = this.currentEndIndex

			// Se não tem dados carregados mas precisa exibir, carrega os dados iniciais
			if (dadosCarregados === 0 && endIndexNecessario > 0) {
				this.loadInitialData()
				return
			}

			// Se precisa de mais dados do que já carregou
			if (endIndexNecessario > dadosCarregados && dadosCarregados < this.totalRecords) {
				this.loadMoreData()
			} else {
				// Dados já carregados, restaura modelList
				this.modelList = this.allLoadedData
				this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
			}
			// O computed modelsToBeShowedAndTotalPagination faz o slice automaticamente
		},
		loadInitialData() {
			if (this.isLoadingMore) return

			this.isLoadingMore = true
			this.proximaPaginaServidor = 1
			getAllAplicaPrognose(0, this.batchSize, '', this.filtrosAtuais())
				.then((response) => {
					this.totalRecords = response.data.totalRegistros || 0
					const plantios = response.data.result
					if (plantios && plantios.length > 0) {
						// Guarda o tamanho real retornado pelo backend
						this.actualBatchSize = plantios.length
						plantios.forEach((plantio) => this.formatarDados(plantio))
						this.allLoadedData = plantios
						// modelList contém todos os dados carregados, o computed faz o slice para exibição
						this.modelList = plantios
					}
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
				.catch(() => {
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
		},
		loadMoreData() {
			if (this.isLoadingMore) return

			this.isLoadingMore = true
			this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
			this.modelList = []
			const pageNumber = this.proximaPaginaServidor

			getAllAplicaPrognose(pageNumber, this.batchSize, '', this.filtrosAtuais())
				.then((response) => {
					const plantios = response.data.result
					if (plantios && plantios.length > 0) {
						this.proximaPaginaServidor = pageNumber + 1
						plantios.forEach((plantio) => this.formatarDados(plantio))
						// Concatena os novos dados
						this.allLoadedData = this.allLoadedData.concat(plantios)
						// modelList contém todos os dados carregados, o computed faz o slice para exibição
						this.modelList = this.allLoadedData
					}
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
				.catch(() => {
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
					this.isLoadingMore = false
				})
		},
		saveClick() {
			this.aplicandoPrognose = true
			const checadas = this.modelList.filter((f) => f.isCheckedToDelete)
			var idades = checadas.map((m) => m.idade)
			// reduce (sem spread) — Math.max.apply estoura "Maximum call stack size
			// exceeded" se muitos itens forem selecionados.
			var idadeMax = idades.reduce((max, i) => (i > max ? i : max), -Infinity)

			if (this.model.horizonteDeProjecao <= idadeMax) {
				this.teste = true
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: this.$t('horizonteDeProjecao'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})

				this.aplicandoPrognose = false
			} else {
				// Vínculo ASSÍNCRONO (contrato lean): manda só prognose + idade + pares
				// plantio/inventário — o worker resolve fazenda/estrato/códigos direto
				// no acervo. O job aparece na central de processamentos e o sino avisa
				// ao concluir/falhar; a tela fica livre (sem reload nem espera de 10min).
				const plantios = this.modelList.filter((f) => f.isCheckedToDelete)
				const prognose = this.prognose.find((p) => p.id === this.model.prognoseEscolhida)
				const descricao = `${prognose?.descricao ?? this.$t('prognosis')} — ${plantios.length} ${this.$t(
					'plantation',
				).toLowerCase()}(s)`

				vinculaPrognoseAsync({
					prognoseId: this.model.prognoseEscolhida,
					idadeDeProjecao: Number(this.model.horizonteDeProjecao),
					descricao,
					itens: plantios.map((plantio) => ({
						plantioId: plantio.plantioId,
						inventarioFlorestalId: plantio.inventarioFlorestalId,
					})),
				})
					.then(() => {
						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
							messageText: this.$t('linkQueued'),
						})
						this.showForm = false
						this.cleanModel()
						this.modelList.forEach((f) => (f.isCheckedToDelete = false))
						this.aplicandoPrognose = false
					})
					.catch((error) => {
						this.aplicandoPrognose = false
						// O back devolve 400 com a mensagem específica (ex.: vínculo da
						// mesma prognose já em andamento) — mostra ela quando existir.
						const mensagens = error?.response?.data?.errors?.Mensagens
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
							messageText: mensagens?.length
								? mensagens.join(' ')
								: this.$t('erro_vincular_prognose'),
						})
					})
			}
		},
		prognoseAplica() {
			this.handleSelectionChanges()
			this.titleForm = 'Aplica Prognose'
			this.changeFormAndCloseAllActions()
		},
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},

		/**
		 * Filtros estruturados atuais (os aplicados pelo painel), no shape que o
		 * back espera. Listas vazias = sem filtro naquela dimensao.
		 */
		filtrosAtuais() {
			return this.filtrosAplicados
		},

		/**
		 * "filtrar" do painel: guarda os IDs aplicados + resumo do CSV e refaz a
		 * busca do zero.
		 */
		onFiltrar({ fazendasIds, talhoesIds, estratosIds, csvResumo }) {
			this.filtrosAplicados = {
				FazendasIds: fazendasIds,
				TalhoesIds: talhoesIds,
				EstratosIds: estratosIds,
			}
			this.csvResumo = csvResumo
			this.aplicarFiltros()
		},

		/**
		 * Copia a lista de itens do CSV sem correspondência (um por linha) para a
		 * área de transferência — facilita revisar/corrigir o arquivo de origem.
		 */
		async copiarNaoEncontrados() {
			const itens = this.csvResumo?.naoEncontrados ?? []
			if (itens.length === 0) return
			await navigator.clipboard.writeText(itens.join('\n'))
			this.naoEncontradosCopiados = true
			setTimeout(() => {
				this.naoEncontradosCopiados = false
			}, 2000)
		},

		/**
		 * "limpar filtros" do painel: zera tudo (inclusive a palavra livre) e
		 * recarrega o acervo completo.
		 */
		onLimparFiltros() {
			this.filtrosAplicados = { FazendasIds: [], TalhoesIds: [], EstratosIds: [] }
			this.csvResumo = null
			if (this.textFilter) {
				// O watcher do textFilter recarrega (ja sem filtros estruturados).
				this.textFilter = ''
				return
			}
			this.aplicarFiltros()
		},

		/**
		 * Aplica os multi-selects no servidor: reseta a paginacao/selecao e refaz a
		 * busca do zero com os filtros atuais (mais a palavra livre, se houver).
		 */
		aplicarFiltros() {
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
			this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
			this.modelList = []
			this.allLoadedData = []
			this.currentStartIndex = 0
			this.currentEndIndex = this.quantityPerPage
			this.atualStartIndex = 0
			this.atualEndIndex = this.quantityPerPage
			this.proximaPaginaServidor = 1
			getAllAplicaPrognose(0, this.batchSize, this.textFilter || '', this.filtrosAtuais())
				.then((response) => {
					this.totalRecords = response.data.totalRegistros || 0
					const plantios = response.data.result || []
					this.actualBatchSize = plantios.length || null
					plantios.forEach((plantio) => this.formatarDados(plantio))
					this.allLoadedData = plantios
					this.modelList = plantios
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
				})
				.catch(() => {
					this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
				})
		},

		/**
		 * Marca para aplicacao TODOS os plantios ja carregados (todas as paginas em
		 * memoria), nao apenas os visiveis na pagina atual.
		 */
		selecionarTodosCarregados() {
			this.modelList.forEach((plantio) => {
				if (!plantio.isBlocked) {
					plantio.isCheckedToDelete = true
				}
			})
		},

		/**
		 * Garante que TODO o resultado filtrado esta em memoria: se ainda ha
		 * registros nao carregados, busca tudo numa chamada (pagSize = total).
		 * Base do select-all do cabecalho e da exportacao completa.
		 */
		async carregarTodoResultadoFiltrado() {
			if (this.allLoadedData.length >= this.totalRecords || this.isLoadingMore) return

			this.isLoadingMore = true
			this.$set(this.tableConfiguration, 'statusTable', this.$t('loading'))
			try {
				const response = await getAllAplicaPrognose(
					0,
					Math.max(this.totalRecords, this.batchSize),
					this.textFilter || '',
					this.filtrosAtuais(),
				)
				const plantios = response.data.result || []
				this.actualBatchSize = plantios.length || null
				plantios.forEach((plantio) => this.formatarDados(plantio))
				this.allLoadedData = plantios
				this.modelList = plantios
				// Tudo carregado: proxima pagina aponta para o fim (loadMore nao refaz).
				this.proximaPaginaServidor = Math.max(1, Math.ceil(plantios.length / this.batchSize))
			} finally {
				this.isLoadingMore = false
				this.$set(this.tableConfiguration, 'statusTable', this.$t('noRecordFound'))
			}
		},

		/**
		 * Checkbox do CABECALHO da grade: vale para o resultado FILTRADO inteiro.
		 * Se ainda ha registros do filtro nao carregados do servidor, carrega tudo
		 * antes de marcar; desmarcar limpa toda a selecao em memoria.
		 */
		async onSelecionarTudo(marcado) {
			if (!marcado) {
				this.limparSelecao()
				return
			}

			await this.carregarTodoResultadoFiltrado()
			this.selecionarTodosCarregados()
		},

		/**
		 * Desmarca todos os plantios selecionados.
		 */
		limparSelecao() {
			this.modelList.forEach((plantio) => {
				plantio.isCheckedToDelete = false
			})
		},
		handleSelectionChanges() {
			const checadas = this.modelList.filter((f) => f.isCheckedToDelete)
			var idades = checadas.map((m) => (m.idade !== undefined ? m.idade : 0))

			if (idades.length > 0) {
				// reduce (sem spread) — ver nota em saveClick.
				this.model.horizonteDeProjecao = idades.reduce((max, i) => (i > max ? i : max), -Infinity)
			} else {
				console.error('Não há idades válidas para calcular o máximo.')
			}
		},

		/**
		 * Baixa CSV com o resultado FILTRADO COMPLETO (nao so as paginas ja
		 * carregadas): garante o carregamento de tudo numa chamada antes de gerar
		 * o arquivo. Campos com ; aspas ou quebra de linha sao escapados (padrao
		 * CSV) — com dezenas de milhares de linhas, uma descricao com ; corrompia
		 * as colunas do arquivo.
		 */
		async downloadCSVVincularPrognose() {
			if (this.exportando) return
			this.exportando = true
			try {
				await this.carregarTodoResultadoFiltrado()

				const cabecalhoDoCsvVincularPrognose = [
					'Fazenda',
					'Talhão',
					'Estrato Florestal',
					'Plantio',
					'Data do Plantio',
					'Idade do Plantio (Meses)',
					'Inventário Florestal',
					'Single Trees',
					'Sítio',
					'Prognose',
				]

				const campo = (valor) => {
					const texto = valor === null || valor === undefined ? '' : String(valor)
					return /[;"\n\r]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto
				}

				const csv = [
					cabecalhoDoCsvVincularPrognose,
					...this.allLoadedData.map((item) => [
						item.fazendaDescricao,
						item.talhaoCodigo,
						item.estratoDescricao,
						item.plantioCodigo,
						item.dataDoPlantio,
						item.idade,
						item.inventarioFlorestalDescricao,
						item.isSingleTrees,
						item.sitio,
						item.prognoseDescricao,
					]),
				]
					.map((linha) => linha.map(campo).join(';'))
					.join('\r\n')

				download(csv, 'export_vincula_prognose.csv', 'text/csv')
			} finally {
				this.exportando = false
			}
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>

<style scoped>
/* ==========================================================================
   Linha 1 - Filtros (fazenda + busca à esquerda, colunas/exportar à direita)
   ========================================================================== */

/* Filtros lado a lado: fazenda com largura fixa, busca ocupa o restante */
.container__crudactions__filtercollums__filter {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.5rem;
}

.busca-filtro {
	flex: 1 1 200px;
	min-width: 0;
}

/* ==========================================================================
   Badge do CSV importado (resumo do filtro + itens não encontrados)
   ========================================================================== */
.csv-resumo {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.75rem;
	margin-top: 0.5rem;
}

.csv-resumo__ok,
.csv-resumo__erro {
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.3rem 0.7rem;
	border-radius: 999px;
	font-size: 0.75rem;
	font-weight: 600;
	white-space: nowrap;
}

.csv-resumo__ok {
	background-color: rgb(var(--color-default), 0.12);
	border: 1px solid rgb(var(--color-default), 0.4);
	color: var(--color-navy-blue);
}

.csv-resumo__erro {
	background-color: rgba(220, 53, 69, 0.08);
	border: 1px solid rgba(220, 53, 69, 0.35);
	color: #b02a37;
	cursor: help;
}

.csv-resumo__copiar {
	border: none;
	background: none;
	padding: 0;
	margin-left: 0.35rem;
	color: inherit;
	font: inherit;
	font-weight: 700;
	text-decoration: underline;
	cursor: pointer;
}

/* Substitui o antigo style inline (border-radius/width fixos com !important)
   do botão Exportar, mantendo a mesma aparência final já usada nas demais
   telas CRUD do projeto (ex.: Fazenda, OrdemDeServico). A prop width-auto
   (ver template) já cuida da largura automática; aqui só ajustamos o
   arredondamento e uma largura mínima confortável para o rótulo. */
.vincular-acoes__botao-exportar {
	border-radius: 5px;
	min-width: 65px;
}

/* ==========================================================================
   Linha 2 - Ações em lote: barra destacada, separada visualmente dos filtros
   ========================================================================== */
.vincular-acoes {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	margin-top: 0.75rem;
	padding: 0.6rem 0.75rem;
	background-color: var(--color-light-blue);
	border: 1px solid rgba(var(--color-primary), 0.1);
	border-radius: 6px;
}

.vincular-acoes__botoes {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.5rem;
}

/* Pequeno separador entre a ação principal (Aplicar prognose) e as ações
   secundárias de seleção, reforçando o agrupamento por função. */
.vincular-acoes__separador {
	width: 1px;
	align-self: stretch;
	min-height: 1.5rem;
	background-color: rgba(var(--color-primary), 0.15);
}

/* Contador de seleção tratado como um badge de status (mesma linguagem visual
   do badge de amostragem usado no planejamento de prognose), não mais como
   texto solto. */
.vincular-acoes__contador {
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.35rem 0.75rem;
	margin-left: auto;
	border-radius: 999px;
	background-color: white;
	border: 1px solid rgba(var(--color-primary), 0.15);
	color: var(--color-gray-dark);
	font-size: 0.75rem;
	font-weight: 600;
	white-space: nowrap;
}

.vincular-acoes__contador i {
	font-size: 0.7rem;
	color: var(--color-gray);
}

.vincular-acoes__contador--ativo {
	background-color: rgb(var(--color-default), 0.12);
	border-color: rgb(var(--color-default), 0.4);
	color: var(--color-navy-blue);
}

.vincular-acoes__contador--ativo i {
	color: rgb(var(--color-default));
}

/* ==========================================================================
   Responsividade: em telas estreitas os grupos quebram de forma limpa
   ========================================================================== */
@media screen and (max-width: 767px) {
	.busca-filtro {
		flex-basis: 100%;
	}

	.vincular-acoes {
		flex-direction: column;
		align-items: stretch;
	}

	.vincular-acoes__botoes {
		justify-content: flex-start;
	}

	.vincular-acoes__separador {
		display: none;
	}

	.vincular-acoes__contador {
		margin-left: 0;
		justify-content: center;
	}
}
</style>
